import { ModelAccessPolicy } from "../../../ModelAccessPolicy";
import Button from "../../../../shared/buttons/Button";
import useCurrentUser from "../../../../account/hooks/useCurrentUser";
import ReprocessIcon from "../../../../shared/Icons/ReprocessIcon";
import SkyeTooltip from "../../../../shared/components/SkyeTooltip";
import { useModelReprocessDialog } from "../../../containers/ReprocessDialog/context";
import { ModelStatus } from "../../../../../models/Model";

const ModelDetailsPageReprocessButton = ({
  model,
}: {
  model: { id: string; status: ModelStatus };
}) => {
  const currentUserCtx = useCurrentUser();
  const { openDialog } = useModelReprocessDialog();

  if (!ModelAccessPolicy.canReprocess(currentUserCtx.user, model)) {
    return null;
  }

  return (
    <SkyeTooltip title="Reprocess this model">
      <Button
        endIcon={<ReprocessIcon />}
        type="light"
        onClick={() => openDialog(model)}
      />
    </SkyeTooltip>
  );
};

export default ModelDetailsPageReprocessButton;
